import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Target, TrendingUp, BookOpen, User, List, Bike, Utensils } from 'lucide-react';

interface NavItem {
  name: string;
  path: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  { name: 'Dashboard', path: '/dashboard', icon: <LayoutDashboard size={20} /> },
  { name: 'Training Plans', path: '/plans', icon: <Target size={20} /> },
  { name: 'Pace Calculator', path: '/paces', icon: <TrendingUp size={20} /> },
];

const resourcesItems: NavItem[] = [
  { name: 'Swim Glossary', path: '/swim-glossary', icon: <BookOpen size={18} /> },
  { name: 'Bike Tips', path: '/bike-tips', icon: <Bike size={18} /> },
  { name: 'Nutrition Guide', path: '/nutrition-guide', icon: <Utensils size={18} /> },
];

const settingsItems: NavItem[] = [
  { name: 'Athlete Settings', path: '/settings/athlete', icon: <User size={20} /> },
  { name: 'Session Types', path: '/session-types', icon: <List size={20} /> },
];

export const Sidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-[#141921] border-r border-[#2d3748] min-h-screen">
      <nav className="p-4">
        <ul className="space-y-2">
          {navItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                end={item.path === '/dashboard'}
                className={({ isActive }) =>
                  `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                    isActive
                      ? 'bg-[rgba(59,130,246,0.1)] text-[#3b82f6] border border-[rgba(59,130,246,0.2)]'
                      : 'text-[#e2e8f0] hover:bg-[#0a0e14] hover:text-[#ffffff]'
                  }`
                }
              >
                {item.icon}
                <span className="font-medium">{item.name}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="mt-8 pt-4 border-t border-[#2d3748]">
          <p className="px-4 text-xs font-medium text-[#718096] uppercase tracking-wider mb-2">Resources</p>
          <ul className="space-y-1">
            {resourcesItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors text-sm ${
                      isActive
                        ? 'bg-[rgba(59,130,246,0.1)] text-[#3b82f6]'
                        : 'text-[#e2e8f0] hover:bg-[#0a0e14] hover:text-[#ffffff]'
                    }`
                  }
                >
                  {item.icon}
                  <span className="font-medium">{item.name}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 pt-4 border-t border-[#2d3748]">
          <p className="px-4 text-xs font-medium text-[#718096] uppercase tracking-wider mb-2">Settings</p>
          <ul className="space-y-2">
            {settingsItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-2 rounded-lg transition-colors text-sm ${
                      isActive
                        ? 'bg-[rgba(59,130,246,0.1)] text-[#3b82f6]'
                        : 'text-[#e2e8f0] hover:bg-[#0a0e14] hover:text-[#ffffff]'
                    }`
                  }
                >
                  {item.icon}
                  <span className="font-medium">{item.name}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </aside>
  );
};
